import { ExamCenterCourseList } from '@exam-center/exam-center-course-list';
import { APP_PERMISSIONS } from '@exam-center/permission';
import { Box, PaperSection } from '@shared/components';
import { PermissionGuard } from '@shared/permissions';

export default function ExamCenterCourseListPage() {
  return (
    <PermissionGuard requiredPermission={APP_PERMISSIONS.EXAM_CENTER_MANAGEMENT.EXAM_COURSE.VIEW}>
      <PaperSection title='หลักสูตรที่เปิดสอบ' sx={{ height: '100%' }}>
        <Box sx={{ p: (theme) => theme.spacing(6), height: '100%' }}>
          <ExamCenterCourseList />
        </Box>
      </PaperSection>
    </PermissionGuard>
  );
}
